import { useMemo } from 'react';
import { Content, FormatContent } from 'src/contexts/ContentContext';
import { WarningMessage } from 'src/core/POS/MessageWithIcon';
import { PosProgressBar } from 'src/core/POS/PosProgressBar/PosProgressBar';
import { Stack } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';
import { FormatContentId } from 'src/utils/constants/formatContentId';

import { BatchPurchaseProgress } from './BatchedPurchaseOrderCreator';
import * as styles from './CreatePurchaseOrderTracker.css';

export const CreatePurchaseOrderTracker = ({
  progress,
}: {
  progress: BatchPurchaseProgress;
}) => {
  const progressBarValue = useMemo(
    () => (progress.processedTicketGroups / progress.totalTicketGroups) * 100,
    [progress.processedTicketGroups, progress.totalTicketGroups]
  );
  const progressValue = useMemo(() => {
    return {
      ticketGroupCountDown: `${progress.processedTicketGroups} / ${progress.totalTicketGroups}`,
      eventCountDown: `${progress.processedEvents} / ${progress.totalEvents}`,
    };
  }, [
    progress.processedEvents,
    progress.processedTicketGroups,
    progress.totalEvents,
    progress.totalTicketGroups,
  ]);

  return (
    <Stack
      direction="column"
      gap="l"
      width="full"
      alignItems="center"
      justifyContent="center"
      className={styles.trackerContainer}
    >
      <WarningMessage
        message={<Content id={ContentId.CreatePurchaseOrderProgressMessage} />}
      />
      <PosProgressBar value={progressBarValue} style={{ width: '100%' }} />
      <span>
        <FormatContent
          id={FormatContentId.CreatePurchaseOrderProgressTracker}
          params={[
            progressValue.ticketGroupCountDown,
            progressValue.eventCountDown,
          ]}
        />
      </span>
    </Stack>
  );
};
